"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createAction = exports.asLoad = exports.asReset = exports.asSuccess = exports.asRequest = exports.asError = exports.toLoad = exports.toReset = exports.toSuccess = exports.toRequest = exports.toError = void 0;

var _evolve = _interopRequireDefault(require("ramda/src/evolve"));

var _concat = _interopRequireDefault(require("ramda/src/concat"));

var _compose = _interopRequireDefault(require("ramda/src/compose"));

var _ = _interopRequireDefault(require("ramda/src/__"));

var toError = (0, _concat["default"])(_["default"], '_ERROR');
exports.toError = toError;
var toRequest = (0, _concat["default"])(_["default"], '_REQUEST');
exports.toRequest = toRequest;
var toSuccess = (0, _concat["default"])(_["default"], '_SUCCESS');
exports.toSuccess = toSuccess;
var toReset = (0, _concat["default"])(_["default"], '_RESET');
exports.toReset = toReset;
var toLoad = (0, _concat["default"])(_["default"], '_LOAD');
exports.toLoad = toLoad;

var setStatus = function setStatus(statusFn) {
  return (0, _evolve["default"])({
    type: statusFn
  });
};

var asError = setStatus(toError);
exports.asError = asError;
var asRequest = setStatus(toRequest);
exports.asRequest = asRequest;
var asSuccess = setStatus(toSuccess);
exports.asSuccess = asSuccess;
var asReset = setStatus(toReset);
exports.asReset = asReset;
var asLoad = setStatus(toLoad);
exports.asLoad = asLoad;

var createAction = function createAction(type, staticPayload) {
  function action() {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var attrs = arguments.length > 1 ? arguments[1] : undefined;
    return {
      type: type,
      payload: staticPayload || payload,
      attrs: attrs
    };
  }

  ;
  action.type = type;
  action.error = (0, _compose["default"])(asError, action);
  action.request = (0, _compose["default"])(asRequest, action);
  action.success = (0, _compose["default"])(asSuccess, action);
  action.reset = (0, _compose["default"])(asReset, action);
  action.load = (0, _compose["default"])(asLoad, action);
  action.errorType = toError(type);
  action.requestType = toRequest(type);
  action.successType = toSuccess(type);
  action.resetType = toReset(type);
  action.loadType = toLoad(type);
  return action;
};

exports.createAction = createAction;